import { useIntl } from "@leagueplatform/locales";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

export const useUserSettingsLinksConfig = () => {
  const { formatMessage } = useIntl();
  const userSettingsLinks = [
    {
      items: [
        {
          text: formatMessage({ id: "STR_LOG_OUT" }),
          to: APP_MANAGED_ROUTES.SIGN_OUT,
        },
      ],
    },
  ];

  return { userSettingsLinks };
};
